import React from 'react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
import { SecurePaymentBadge } from './SecurePaymentBadge';
import { PRICE } from '../data/content';
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-ink py-24 md:py-32" aria-labelledby="cta-final" data-id="element-80" data-mp="19g0dhjtkbyky">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-0 h-72 w-72 -translate-x-1/2 rounded-full bg-gold/10 blur-3xl" data-id="element-81" data-mp="15ckist1208aw" />
      <div className="relative mx-auto max-w-3xl px-6 text-center lg:px-8" data-id="element-82" data-mp="1ee1w63n2tvvw">
        <Reveal data-id="element-83" data-mp="1eds7qkhojwsb">
          <p className="font-sans text-[0.6rem] uppercase tracking-luxe text-goldsoft" data-id="element-84" data-mp="1ec7jfclyla2w">
            Tu regreso
          </p>
          <h2 id="cta-final" className="mt-6 font-display text-[2.3rem] font-light leading-[1.15] text-ivory sm:text-5xl" data-id="element-85" data-mp="1o3bpfmtnpkll">
            La mujer que extrañas <span className="italic text-goldsoft" data-id="element-86" data-mp="223w7uhvnteek">todavía está ahí.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.1} data-id="element-87" data-mp="1x6ctlhyyp1mm">
          <p className="mx-auto mt-8 max-w-reading font-sans text-[1.02rem] font-light leading-[1.9] text-sand/85" data-id="element-88" data-mp="n5m909ym4i5k">
            No desapareció. Solo quedó esperando que volvieras a elegirla.
          </p>
          <p className="mx-auto mt-4 max-w-reading font-display text-2xl italic text-ivory" data-id="element-89" data-mp="x41wm2yfl9ab">
            Hoy puede ser el primer día de tu regreso.
          </p>
        </Reveal>

        <Reveal delay={0.18} data-id="element-90" data-mp="120in33t3rzqk">
          <div className="mt-12 flex flex-col items-center gap-5" data-id="element-91" data-mp="16505ayjte4z8">
            <CTAButton location="cta-final" className="w-full !bg-ivory !text-ink hover:!bg-goldsoft sm:w-auto" data-id="element-92" data-mp="162m9gnhb8oqm">
              Sí, quiero volver a ser yo
            </CTAButton>
            <p className="font-display text-3xl font-light text-goldsoft" data-id="element-93" data-mp="1fv1rtlwirfc1">{PRICE}</p>
            <p className="font-sans text-[0.66rem] uppercase tracking-[0.16em] text-sand/70" data-id="element-94" data-mp="1kstk4h12t3gr">
              Pago único · Acceso inmediato · Garantía de 7 días
            </p>
            <SecurePaymentBadge tone="dark" data-id="element-95" data-mp="1tt9nlqhtkalm" />
          </div>
        </Reveal>
      </div>
    </section>;
}